import { IonHeader, IonModal, IonToolbar, IonFooter } from '@ionic/react'
import { useEffect, useState } from 'react'
import { StoryType } from '~/widgets/Stories'
import { useModal } from '~/shared/ui/Modal'
import { myPalette } from '~/shared/ui/theme'
import { enterAnimation, leaveAnimation } from './animation'
import { CubeSwiper } from './CubeSwiper'

type FullStoriesProps = {
  stories: StoryType[]
  selectedStoryId: UniqueId | null
  onClose: () => void
}

export function FullStories({
  stories,
  selectedStoryId,
  onClose,
}: FullStoriesProps) {
  const { isModalShow, closeModal, openModal } = useModal()
  const [isShowCubeSwiper, setIsShowCubeSwiper] = useState(false)

  const handleDidDismiss = () => {
    closeModal()
    setIsShowCubeSwiper(false)
  }
  const handleDidPresent = () => {
    setIsShowCubeSwiper(true)
  }

  const handleClose = () => {
    closeModal()
    onClose()
  }

  useEffect(() => {
    if (selectedStoryId) {
      openModal()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStoryId])

  return (
    <IonModal
      keepContentsMounted={false}
      isOpen={isModalShow}
      onDidDismiss={handleDidDismiss}
      onDidPresent={handleDidPresent}
      enterAnimation={enterAnimation}
      leaveAnimation={leaveAnimation}
      data-testid='story-modal'
      style={{
        '--height': '100%',
        '--background': myPalette.black.main,
        '--border-radius': '0',
      }}
    >
      <IonHeader>
        <IonToolbar style={{ '--background': 'transparent', height: 0 }} />
      </IonHeader>
      <div
        style={{
          height: '100%',
        }}
      >
        {isShowCubeSwiper && (
          <CubeSwiper
            stories={stories}
            selectedStoryId={selectedStoryId}
            onClose={handleClose}
          />
        )}
      </div>
      <IonFooter>
        <IonToolbar style={{ '--background': 'transparent', height: 0 }} />
      </IonFooter>
    </IonModal>
  )
}
